// extracted by mini-css-extract-plugin
module.exports = {"normal":"normal___1x_Ji"};